import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { useCountry, Country } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<Country>
    useData={useCountry}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
